import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import { getPosts } from "@/lib/api";
import { categoryStyle } from "@/lib/constants";

function formatDate(iso) {
    if (!iso) return "";
    try {
        return new Date(iso).toLocaleDateString(undefined, {
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    } catch {
        return iso;
    }
}

export default function LatestPostsPage() {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        Promise.all([getPosts("latest"), getPosts("recent"), getPosts("featured")])
            .then(([a, b, c]) => setPosts([...a, ...b, ...c]))
            .catch(() => setPosts([]));
    }, []);

    return (
        <div data-testid="latest-page">
            <div className="px-4 md:px-8 lg:px-12 mt-10">
                <h1 className="section-title text-left mb-2">Latest Posts</h1>
                <p className="font-sofia text-[#1B1B1B]/70 mb-10">
                    Every story published, newest first.
                </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 px-4 md:px-8 lg:px-12">
                <div className="lg:col-span-8 space-y-16">
                    {posts.map((post) => (
                        <article
                            key={post.id}
                            className="relative pl-0 md:pl-28"
                            data-testid={`latest-article-${post.slug}`}
                        >
                            <span
                                className="badge-category md:absolute md:top-2 md:left-0 inline-block mb-3 md:mb-0"
                                style={categoryStyle(post.category)}
                            >
                                {post.category}
                            </span>
                            <p className="font-sofia text-sm text-[#1B1B1B]/70">
                                {formatDate(post.date)}
                            </p>
                            <h2 className="font-poppins font-bold uppercase tracking-tight text-xl sm:text-2xl mt-1 leading-tight">
                                <Link
                                    to={`/post/${post.slug}`}
                                    className="hover:text-[#E63B26] transition"
                                    data-testid={`latest-article-title-${post.slug}`}
                                >
                                    {post.title}
                                </Link>
                            </h2>
                            {post.sub_header && (
                                <p className="italic font-sofia text-[#1B1B1B]/80 mt-1">
                                    {post.sub_header}
                                </p>
                            )}
                            <div className="mt-3 font-sofia text-sm leading-relaxed text-[#1B1B1B]/85 space-y-1">
                                <p className="font-bold text-[#1B1B1B]">
                                    {post.contact_name}
                                </p>
                                <p>
                                    {post.business} · {post.phone}
                                </p>
                                <p className="text-[#E63B26]">{post.website}</p>
                            </div>
                            <p className="mt-4 font-sofia text-[#1B1B1B]/85 leading-relaxed whitespace-pre-line">
                                {post.body}
                            </p>
                            <div className="mt-4 text-center font-poppins text-[#1B1B1B]/40 tracking-[0.4em]">
                                ###
                            </div>
                        </article>
                    ))}
                </div>

                <div className="lg:col-span-4">
                    <Sidebar variant="with-ads" />
                </div>
            </div>
        </div>
    );
}
